import axios from 'axios'
import DOMPurify from 'dompurify'
import router from '../router'
import store from '../store'
const api = axios

api.defaults.baseURL = process.env.VUE_APP_API
api.defaults.headers.common.Accept = 'application/json'
api.defaults.headers.common['Content-Type'] = 'application/json'
// api.defaults.headers.post['Content-Type'] = 'multipart/form-data'

const CancelToken = axios.CancelToken
let cancel
const lastUrl = []

const notCanceledUrls = ['recipients', 'emails']

function sanitizeData(data) {
    if (typeof data === 'string') {
        return DOMPurify.sanitize(data, { ALLOWED_TAGS: [] })
    }
    if (typeof data === 'object' && data !== null) {
        Object.keys(data).forEach(key => {
            data[key] = sanitizeData(data[key])
        })
    }
    return data
}

api.interceptors.request.use(
    async config => {
        const token = store.getters.authToken

        if (config.url === '/token/refresh') {
            // Do nothing
        } else if (token) {
            config.headers.common.Authorization = `Bearer ${token}`
        }

        config.data = sanitizeData(config.data)

        if (notCanceledUrls.includes(config.url.split('?')[0])) return config

        if ((config.config && config.config.noCancel) || config.noCancel) return config

        if (cancel && lastUrl.includes(config.url.split('?')[0])) {
            cancel()
        }
        if (lastUrl.length > 0) {
            lastUrl.shift()
        }
        config.cancelToken = new CancelToken(function executor(c) {
            cancel = c
        })
        lastUrl.push(config.url.split('?')[0])
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

let isRefreshing = false
let requestQueue = []

axios.interceptors.response.use(
    response => {
        return response
    },
    async error => {
        if (error.response && error.response.status === 500) {
            const tokenExpiredMessage = 'Signature verification failed'

            if (
                error.response.data.message
                    .toLowerCase()
                    .includes(tokenExpiredMessage.toLowerCase())
            ) {
                router.push({ name: 'logout' })
            }
        }

        if (error.response && error.response.status === 403) {
            router.push({ name: 'logout' })
            return Promise.reject(error)
        }

        if (error.response && error.response.status === 401) {
            if (error.config.url === '/token/refresh') {
                router.push({ name: 'logout' })
                return Promise.reject(error)
            }

            const retryOriginalRequest = new Promise(resolve => {
                requestQueue.push(resolve)
            })

            if (!isRefreshing) {
                isRefreshing = true
                try {
                    const refreshToken = await store.$storage.getItem('refreshToken')
                    if (!refreshToken) {
                        router.push({ name: 'logout' })
                        return Promise.reject(error)
                    }

                    const refreshResponse = await axios.post('/token/refresh', {
                        access_token: store.getters.authToken,
                        refresh_token: refreshToken
                    })

                    const newToken = refreshResponse.data.access_token
                    const newRefreshToken = refreshResponse.data.refresh_token

                    await store.$storage.setItem('authToken', newToken)
                    await store.$storage.setItem('refreshToken', newRefreshToken)

                    await store.commit('SET_AUTH_TOKEN', newToken)
                    await store.commit('SET_REFRESH_TOKEN', newRefreshToken)

                    error.config.headers.Authorization = `Bearer ${newToken}`
                    requestQueue.forEach(cb => cb(newToken))
                    requestQueue = []
                    isRefreshing = false
                    return axios(error.config)
                } catch (refreshError) {
                    router.push({ name: 'logout' })
                    setTimeout(() => {
                        store.dispatch('addNotification', {
                            type: 'danger',
                            content: 'Sesja wygasła. Zaloguj się ponownie.'
                        })
                    }, 100)
                    return Promise.reject(refreshError)
                }
            }

            return retryOriginalRequest.then(token => {
                error.config.headers.Authorization = `Bearer ${token}`
                return axios(error.config)
            })
        }

        if (error.response && error.response.status === 405) {
            store.dispatch('addNotification', {
                type: 'danger',
                content: 'Jesteś w trybie odczytu i nie możesz wykonać tej operacji.'
            })
        }

        return Promise.reject(error)
    }
)

export default api
